import React from 'react'

const Image = ({src, alt, className}) => {
    return (
        <img loading='lazy' src={src} alt={alt} className={className} />
    )
}

export default Image
